import { Component, OnInit } from '@angular/core';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';

@Component({
  selector: 'app-document-requirements',
  templateUrl: './document-requirements.component.html',
  styleUrls: ['./document-requirements.component.scss'],
})
export class DocumentRequirementsComponent implements OnInit {

  requirementsList: any[];
  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private navigationService: NavigationService,
    private parameterService: ParametersService,
  ) {
    this.headerService.show(false, true, true);
  }

  ngOnInit() {
    this.requirementsList = this.parameterService.getSetting(OpEnum.DOCUMENT_REQUIREMENTS).documentsList;
  }

  next(code: number) {
    this.navigationService.nextStep(code.toString());
  }
}
